<div class="form-parent">
  <div class="text">[{{ "ClientApp.FrontOffice.Catalog.Additive.ToDefineProductWithoutHeading" | translate }}]</div>
  <kgrid
    [apiName]="apiName"
    [noAutoFitColumns]="true"
    [label]="label"
    [areaName]="areaName"
    [name]="apiName"
    reportName="Additive"
    pathPreFix="SALE"
    [isMulti]="true"
    [IgnoreDeletePermission]="IgnoreDelete"
    [deleteMessage]="deleteMessage"
    [inputEditorform]="inputEditorform"
    [isAdd]="isAdd"
    [isEdit]="isEdit"
    [isDelete]="isDelete">
  </kgrid>
</div>
